import * as React from "react";
import ExpandableSection from "@amzn/awsui-components-react/polaris/expandable-section";
import FormField from "@amzn/awsui-components-react/polaris/form-field";
import Input from "@amzn/awsui-components-react/polaris/input";
import Textarea from "@amzn/awsui-components-react/polaris/textarea";
import Toggle from "@amzn/awsui-components-react/polaris/toggle";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import ColumnLayout from "@amzn/awsui-components-react/polaris/column-layout";
import DatePicker from "@amzn/awsui-components-react/polaris/date-picker";

export interface ControlledSubstanceData {
  prescriberName: string;
  contactPerson: string;
  contactPersonJobTitle: string;
  approvedAt: string;
  pharmacistJustification: string;
  isFlaggedForReview: boolean;
}

export const EMPTY_CONTROLLED_SUBSTANCE: ControlledSubstanceData = {
  prescriberName: "",
  contactPerson: "",
  contactPersonJobTitle: "",
  approvedAt: "",
  pharmacistJustification: "",
  isFlaggedForReview: false,
};

interface Props {
  data: ControlledSubstanceData;
  onChange: (updated: ControlledSubstanceData) => void;
}

class ControlledSubstanceFields extends React.Component<Props> {
  render() {
    const { data, onChange } = this.props;

    return (
      <ExpandableSection headerText="Controlled Substance Details">
        <SpaceBetween size="m">
          <ColumnLayout columns={2}>
            <FormField label="Prescriber Name" description="Required">
              <Input
                value={data.prescriberName}
                onChange={({ detail }) => onChange({ ...data, prescriberName: detail.value })}
                placeholder="Dr. Smith"
              />
            </FormField>
            <FormField label="Contact Person" description="Required">
              <Input
                value={data.contactPerson}
                onChange={({ detail }) => onChange({ ...data, contactPerson: detail.value })}
                placeholder="Jane Doe"
              />
            </FormField>
          </ColumnLayout>

          <ColumnLayout columns={2}>
            <FormField label="Contact Person Job Title" description="Required">
              <Input
                value={data.contactPersonJobTitle}
                onChange={({ detail }) => onChange({ ...data, contactPersonJobTitle: detail.value })}
                placeholder="Pharmacy Technician"
              />
            </FormField>
            <FormField label="Approved At" description="Required">
              <DatePicker
                value={data.approvedAt}
                onChange={({ detail }) => onChange({ ...data, approvedAt: detail.value })}
                placeholder="YYYY/MM/DD"
              />
            </FormField>
          </ColumnLayout>

          <FormField label="Pharmacist Justification" description="Required">
            <Textarea
              value={data.pharmacistJustification}
              onChange={({ detail }) => onChange({ ...data, pharmacistJustification: detail.value })}
              placeholder="Clinical justification for override..."
              rows={3}
            />
          </FormField>

          <Toggle
            checked={data.isFlaggedForReview}
            onChange={({ detail }) => onChange({ ...data, isFlaggedForReview: detail.checked })}
          >
            Flagged for Review
          </Toggle>
        </SpaceBetween>
      </ExpandableSection>
    );
  }
}

export default ControlledSubstanceFields;
